import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
} from '@material-ui/core';

import * as mainActions from '../../main/actions';
import classes from '../../css/getCSS';
import * as commonActions from '../../common/actions';


class SiteSelectPanel extends Component {
  state = {
    menuOpen: false,
    anchorEl: null,
  }

  componentDidMount() {
    if (this.props.sites.length === 0) {
      this.props.getSites(true);
    }
  }

  openSiteMenu = (event) => {
    this.setState({
      menuOpen: true,
      anchorEl: event.currentTarget,
    });
  }

  closeSiteMenu = () => {
    this.setState({
      menuOpen: false,
    });
  }

  render() {
    return (
      <div className={classes.rightWrapper}>
        <div className={[classes.card, classes.noPadding].join(' ')} style={{ backgroundColor: '#fff' }}>
          <List component="nav">
            <ListItem
              button
              aria-haspopup="true"
              aria-controls="lock-menu"
              aria-label="Select Site menu"
              onClick={this.openSiteMenu}
            >
              <ListItemText
                primary="Change Site"
                secondary={`Current: ${this.props.site.name}`}
              />
            </ListItem>
          </List>
          <Menu
            id="lock-menu"
            anchorEl={this.state.anchorEl}
            open={this.state.menuOpen}
            onClose={this.closeSiteMenu}
          >
            {this.props.sites.map(site => (
              <MenuItem
                key={site.id}
                onClick={() => this.props.selectSite(site)}
              >
                {site.name}
              </MenuItem>
            ))}
          </Menu>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    site: state.common.site,
    sites: state.common.sites,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(mainActions.onUnmount()),
    getSites: dropdown => dispatch(commonActions.getSites(dropdown)),
    selectSite: site => dispatch(commonActions.selectSite(site)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteSelectPanel);



// WEBPACK FOOTER //
// ./src/dashboard/containers/SiteSelectPanel.js